import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HubTimezoneMessageComponent } from './hub-timezone-message.component';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [HubTimezoneMessageComponent],
  imports: [CommonModule, TranslateModule, SvgIconModule],
  exports: [HubTimezoneMessageComponent],
})
export class HubTimezoneMessageModule {}
